
export const tdf = {
  'T-IP': [
    { label: 'Is this proposal in reference to a requirement requested by the DOI?', key: 'seek_proposal', cellMargin: 1 },

    { label: 'Title of the Requirement (Including product/ system/ item/ etc.)', key: 'title', cellMargin: 1 },

    { label: '2(a) Description of major system/sub-system and where the item/ product is to be utilised/ fitted.', key: 'major_description', cellMargin: 1 },
    { label: '2(b) Reason for pursuing project under TDF scheme.', key: 'reason_pursuing', cellMargin: 1 },

    { label: '3. Technology Area (Discipline, Sub-discipline etc).', key: 'technology_area', cellMargin: 1 },
    { label: '4. Objective (to cover product/ system/ Item).', key: 'objective', cellMargin: 1 },

    { label: '5. Description', key: '', cellMargin: 2 },
    { label: '5.1 Details of existing system and its use', key: 'existing_system', cellMargin: 1 },
    { label: '5.2 Whether import/ available through indigenisation.', key: 'import_indigenisation', cellMargin: 1 },
    { label: '5.3 Cost of Present System/ LPP details.', key: 'cost_system', cellMargin: 1 },
    { label: '5.4 Deficiency in the existing system.', key: 'deficiency_system', cellMargin: 1 },
    { label: '5.5 How deficiency plugged/addressed presently', key: 'deficiency_plugged', cellMargin: 1 },
    { label: '5.6 What will proposed system do', key: 'proposed_system', cellMargin: 1 },
    { label: '5.7 Who will use the system and how', key: 'use_system', cellMargin: 1 },
    { label: '5.8 What problem will this solve', key: 'problem_solve', cellMargin: 1 },

    { label: '6. Functional and Operational requirements in Qualitative terms', key: '', cellMargin: 2 },
    { label: '6.1 Functional Parameters', key: 'functional_parameters', cellMargin: 1 },
    { label: '6.2 Physical Constraints', key: 'physical_constraints', cellMargin: 1 },
    { label: '6.3 Environmental Requirements', key: 'environmental_requirements', cellMargin: 1 },
    { label: '6.4 Reliability/Maintainability', key: 'reliability_maintainability', cellMargin: 1 },
    { label: '6.5 Usability', key: 'usability', cellMargin: 1 },
    { label: '6.6 Any Other Information', key: 'any_other', cellMargin: 1 },

    { label: '7. Functional and Operational requirements in Quantitative terms', key: '', cellMargin: 2 },
    { label: '7.1 Functional Specification', key: 'functional_specification', cellMargin: 1 },
    { label: '7.2 Physical Specification', key: 'physical_specification', cellMargin: 1 },
    { label: '7.3 Environmental Specification', key: 'environmental_specification', cellMargin: 1 },
    { label: '7.4 Reliability and maintainability specifications', key: 'reliability_specification', cellMargin: 1 },
    { label: '7.5 Usability', key: 'usability_specification', cellMargin: 1 },
    { label: '7.6 Any Other Relevant Information', key: 'other_specification', cellMargin: 1 },

    { label: '8. Contemporary solutions known nationally and/or internationally (if nil, then source of idea)', key: 'contemporary_solution', cellMargin: 1 },
    { label: '9. Miscellaneous Information', key: 'miscellaneous_information', cellMargin: 1 },
    { label: '10. References', key: 'references', cellMargin: 1 },
    { label: '11. Keywords', key: 'keywords', cellMargin: 1 },
    { label: '12. Estimated requirement for the Indian Navy over three to five years including number of prototypes required and likely delivery location of prototype', key: 'estimated_requirement' },
    { label: '13. Testing Methodology, Free Issue Material, Acceptance Criteria/ Type Tests Required / Venue of testing', key: 'testing_methodology', cellMargin: 1 },
    { label: '14. Likely Civil Spin Offs (if envisaged)', key: 'civil_spin', cellMargin: 1 },

    { label: '15. Technology Readiness Level (Whether the proposed technology has been demonstrated in India and needs scaling up/ modification and not an academic project)', key: 'technology_readiness', cellMargin: 1 },
    { label: '16. Feasibility Studies (attach if available)', key: 'feasibility_studies', cellMargin: 1 },
    { label: '17. Proposal is an equipment/ spare (is it an import substitute/ replacement/ upgrade/ new induction). Brief explanation', key: 'proposal_explain', cellMargin: 1 },
    { label: '18. QA Agency (DQA/ CEMILAC etc)', key: 'qa_agency', cellMargin: 1 },

    { label: '19. Whether any classified information included in SoC (Yes/No)?', key: 'classified_information', cellMargin: 1 },
    { label: '20. Concurrence by APSO accorded date (Yes/ No)', key: 'concurrence_apso', cellMargin: 1 },

    { label: '22. Nodal Officer Landline', key: 'nodal_officer_landline', cellMargin: 1 },
    { label: '22. Nodal Officer Mobile', key: 'nodal_officer_mobile', cellMargin: 1 },
    { label: '22. Nodal Officer Email', key: 'nodal_officer_email', cellMargin: 1 },

    { label: '23. Any Other Information', key: 'any_other_information', cellMargin: 1 },
  ],
  "makeI_02": [],
  "A-VCNS": [],
  "tdf_tpr": [{ label: 'TPR From', key: 'user_lab_armed_forces', cellMargin: 2 }],
  "makeI_06": [{ label: 'Feasibility Study From ', key: 'comment', cellMargin: 2 }],
  'pmmg_con': [{ label: "PMMG Constitution" }],
  "C-RFI": [{ label: 'Concurrence on RFI', key: 'justification', cellMargin: 2 }],
  "RS-TDF": [{ label: 'Firm Response Submission ', key: 'vendors', cellMargin: 2 }],
  "tdf_drdopdd": [{ label: 'DRDO PDD  ', key: 'comment', cellMargin: 2 }],
  "tdf_finalpdd": [{ "label": "Final PDD Upload" },],
  "tdf_soc-aon": [{ "label": "Preparation of SoC for AoN", }],
  "aon_mom": [{ label: 'Empowered committee MoM upload', key: 'comment', cellMargin: 2 }],
  "makeI_14": [{ label: 'Issue of RFP', key: 'comment', cellMargin: 2 }],
  "DPR-SUB": [{ label: 'DPR Submission', key: 'vendor', cellMargin: 2 }],
  "tdf_006": [{ label: 'Cost Negotiation', key: 'justification', cellMargin: 2 }],
  "makeI_35": [{ label: 'Award of Contract', key: 'comment', cellMargin: 2 }],
  "Rev_012": [{ "name": "Upload Approved QAP and ATP", "code": "Rev_012" }],
  'tdf_apppdr': [{ label: 'Draft PDR & Approved PDR Protocol', key: 'comment', cellMargin: 2 }],
  'tdf_appcdr': [{ label: 'Draft CDR & Approved CDR Protocol', key: 'comment', cellMargin: 2 }],
  'tdf_fats_r': [{ label: 'Draft FATs protocol, Approved FAT Protocol and FATs Report', key: 'comment', cellMargin: 2 }],
  'tdf_hat': [{ label: 'Draft HATs protocol, Approved HATs Protocol and HATs Report', key: 'comment', cellMargin: 2 }],
  'tdf_sats': [{ label: 'Draft SATs protocol, Approved SATs Protocol and SATs Report', key: 'comment', cellMargin: 2 }],
  'tdf_025': [{ label: 'Production and Supply', key: 'comment', cellMargin: 2 }],
  'tdf_026': [{ label: 'Documentation and ToT', key: 'comment', cellMargin: 2 }],
  'tdf_faopd': [{ label: 'Formal Acceptance of Prototype Delivery', key: 'comment', cellMargin: 2 }],
  "P-PSQR": [{ label: 'Preparation of PSQR from PDD', key: 'justification', cellMargin: 2 }],
  'makeI_23': [{ label: 'PSQRs to SQRs', key: 'justification', cellMargin: 2 }],
  'tdf_appsoc': [{ label: 'Approval on SOC by SPB', }],
  "AON-PRE": [{ label: 'AON Procurement', key: 'comment', cellMargin: 2 }],
  "R-BM": [{ label: 'Benchmarking', key: 'justification', cellMargin: 2 }],
  "TDF-RFP": [{ label: 'RFP Document Formulation', key: 'justification', cellMargin: 2 }],
  "makeI_32": [{ label: 'Cost Negotiation Committee CNC', key: 'justification', cellMargin: 2 }],
  "AWD-PRO": [{ label: 'Award of Contract (Procurrement)', key: 'comment', cellMargin: 2 }],
  "R_029": [{ label: 'Bulk Production', key: 'justification', cellMargin: 2 }],
  "R_030": [{ label: 'Project Closure', key: 'justification', cellMargin: 2 }],



}

export const revenue = {
  "R-ND": [
    { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
     { label: 'For which Platform', key: 'platform', cellMargin: 1 },
    { label: 'Mode of Tender', key: 'tenderMode', cellMargin: 1 },
    { label: 'Equipment', key: 'equipment', cellMargin: 1 },
    { label: 'System', key: 'system', cellMargin: 1 },
    { label: 'Total Quantity Required', key: 'qtyReqd', cellMargin: 1 },
    { label: 'Quantity Prototype', key: 'qtyPrototype', cellMargin: 1 },
    { label: 'Quantity Bulk (MOQ)', key: 'qtyBulk', cellMargin: 1 },
    { label: 'Estimated Total Cost in (INR)', key: 'estimatedDevelopmentCost', cellMargin: 1 },
    { label: 'Estimated Unit Cost in (INR)', key: 'estimatedUnitCost', cellMargin: 1 },
    { label: 'Last Purchase Price in (INR)', key: 'llp', cellMargin: 1 },
    { label: 'POEV Cost in (INR)', key: 'poev', cellMargin: 1 },
    { label: 'Consignee', key: 'consignee', cellMargin: 1 },
    { label: 'Brief Description / Technical Details', key: 'technologyInsertion', cellMargin: 2 },
    { label: 'Justification for Mode of Tender', key: 'justificationText', cellMargin: 2 },
    { label: 'Any export potential of the proposed item', key: 'exportPotential', cellMargin: 2 }


  ],
  "makeI_02": [  ],
  "R-FSOTR": [
    { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: 'For which Platform', key: 'platform', cellMargin: 1 },
    { label: 'Mode of Tender', key: 'tenderMode', cellMargin: 1 },
    { label: 'Equipment', key: 'equipment', cellMargin: 1 },
    { label: 'System', key: 'system', cellMargin: 1 },
    { label: 'Total Quantity Required', key: 'qtyReqd', cellMargin: 1 },
    { label: 'Quantity Prototype', key: 'qtyPrototype', cellMargin: 1 },
    { label: 'Quantity Bulk (MOQ)', key: 'qtyBulk', cellMargin: 1 },
    { label: 'Estimated Total Cost in (INR)', key: 'estimatedDevelopmentCost', cellMargin: 1 },
    { label: 'Estimated Unit Cost in (INR)', key: 'estimatedUnitCost', cellMargin: 1 },
    { label: 'Last Purchase Price in (INR)', key: 'llp', cellMargin: 1 },
    { label: 'POEV Cost in (INR)', key: 'poev', cellMargin: 1 },
    { label: 'Consignee', key: 'consignee', cellMargin: 1 },
    { label: 'Brief Description / Technical Details', key: 'technologyInsertion', cellMargin: 2 },
    { label: 'Justification for Mode of Tender', key: 'justificationText', cellMargin: 2 },
    { label: 'Any export potential of the proposed item', key: 'exportPotential', cellMargin: 2 },
    { label: 'Remarks', key: 'Remarks', cellMargin: 2 }
  ],
  "R-AIP": [
    { label: 'Remarks', key: 'Remarks', cellMargin: 2 }
  ],

  "R-VI": [],
  "R-RFP-SOC": [
    { label: 'Comment', key: 'noting', cellMargin: 2 },
    { label: 'ARFP Format', key: 'comment', cellMargin: 2 },
  ],
  "R-AoN": [
    { label: 'Comment', key: 'comment', cellMargin: 2 },
    { label: 'RFP', key: 'rfp', cellMargin: 2 },
    { label: 'AON Amount', key: 'aon_amount', cellMargin: 1 },
    { label: 'AON Date', key: 'aon_date', cellMargin: 1 },
    { label: 'CFA', key: 'cfa_name', cellMargin: 1 },
    { label: 'File Number', key: 'file_number', cellMargin: 1 },
  ],

  "R-MCommittee": [],
  "RFP-V": [
    { label: 'RFP Vetting MoM', key: 'justification', cellMargin: 1 },
  ],
  "I-RFP": [
    { label: 'RFP Uploading Date', key: 'upload_rfp_date', cellMargin: 1 },
    { label: 'Tender Mode', key: 'mode_tendor', cellMargin: 1 },
    { label: 'Pre-Bid Meeting?', key: 'has_pre_bid', cellMargin: 1 },
    { label: 'Pre-Bid Meeting Date', key: 'pre_bid_date', cellMargin: 1 },
    { label: 'Pre-Bid Meeting Time', key: 'pre_bid_time', cellMargin: 1 },
    { label: 'Pre-Bid Venue', key: 'pre_bid_venue', cellMargin: 1 },
    { label: 'Bid Submission Date', key: 'bid_submission_date', cellMargin: 1 },
    { label: 'Tender Opening Date', key: 'tendor_opening_date', cellMargin: 1 },
    { label: 'Tender Opening Time', key: 'tendor_opening_time', cellMargin: 1 },
    { label: 'Tender Opening Venue', key: 'tendor_opening_venue', cellMargin: 1 },
  ],
  "R-PBC": [
    { label: 'Pre-bid Meeting Justification', key: 'tpre_bid', cellMargin: 1 },

  ],

  "R-TO&RFP": [
    { label: 'Tender Opening Sheet', key: 'justification', cellMargin: 1 },
  ],
  "sotr_rfp_cm": [
    { label: 'SOTR-COMPLIANCE', key: 'sotr_complience', cellMargin: 1 },
    { label: 'RFP-COMPLIANCE', key: 'rfp_complience', cellMargin: 1 },
  ],
  "R-TN": [],
  "F-CA": [
    { label: 'Firm Capacity Assessment', key: 'justification', cellMargin: 1 },
  ],
  "R-TEC": [
    { label: 'Firm Capacity Required', key: 'firmCapability', cellMargin: 1 },
    { label: 'Meeting Date', key: 'meeting_date', cellMargin: 1 },
    { label: 'Meeting Time', key: 'meeting_time', cellMargin: 1 },
    { label: 'TEC Approval Date', key: 'tec_approval', cellMargin: 1 },
    { label: 'Meeting Venue', key: 'meeting_venue', cellMargin: 2 },
  ],
  "R-BM": [
    { label: 'Technical Bid Opening Date', key: 'bid_opening_date', cellMargin: 1 },
    { label: 'Technical Bid Opening Time', key: 'bid_opening_time', cellMargin: 1 },
    { label: 'Technical Bid Opening Venue', key: 'technical_bid_venue', cellMargin: 1 },
    { label: 'Benchmark Price', key: 'benchmark_price', cellMargin: 1 },
    { label: 'Comment', key: 'comment', cellMargin: 2 },
  ],
  "Q-CST": [
    { label: 'Q-Bid Opening Date', key: 'qbid_date', cellMargin: 1 },
    { label: 'Time', key: 'qbid_time', cellMargin: 1 },
    { label: 'Venue', key: 'qbid_venue', cellMargin: 2 },
    { label: 'CST Approval Date', key: 'cst_approval', cellMargin: 1 },
    {label: 'Commercial Bid Opening Sheet',key: 'commercialSheetEditorData',cellMargin: 2},
    {label: 'CST Sheet',key: 'cstSheetEditorData',cellMargin: 2 },
    {label: 'Benchmark Price', key: 'benchmark_price',cellMargin: 1},
    {label: 'Comparative Statement of Tenders', key: 'comment',cellMargin: 1},

   
  ],
  "R-FO":[
    { label: 'IFA/MoD Concurrence Date', key: 'installation_date', cellMargin: 1 },
    { label: 'CFA Approval Date', key: 'delivery_date', cellMargin: 1 },
    { label: 'Final Cost (INR)', key: 'final_cost', cellMargin: 2 },
    { label: 'TEC table', key: 'tec_table', cellMargin: 1 },
    { label: 'Comment', key: 'final_offer', cellMargin: 1 },

  ],
  "R-PSO": [
 { label: 'Financial Concurrence Date', key: 'concurrence_date', cellMargin: 1 },
 { label: 'Final Approval Date', key: 'cfa_date', cellMargin: 1 },
 { label: 'Sanction Order Date', key: 'order_date', cellMargin: 1 },
 { label: 'Contract Conclusion Date', key: 'conclusion_date', cellMargin: 1 }
],
"R-KM": [
 { label: 'Meeting Date', key: 'meeting_date', cellMargin: 1 },
 { label: 'Meeting Venue', key: 'meeting_venue', cellMargin: 2 },
 { label: 'Meeting Time', key: 'meeting_time', cellMargin: 1 },
 { label: 'Comment / Justification', key: 'comment', cellMargin: 2 }
],
"Rev_011": [
 { label:'Final Date of Approved Documents', key:'date', cellMargin:1 },
 { label:'Delivery Date of Prototype System', key:'qap_date', cellMargin:1 },
 { label:'Comments', key:'comment', cellMargin:2 }
],
"Rev_012": [
 { label:'Final Date of Approved Documents', key:'date', cellMargin:1 },
 { label:'Delivery Date of Prototype System', key:'qap_date', cellMargin:1 },
 { label:'Comments', key:'comment', cellMargin:2 }
],

"Rev_017": [
  { label:'FATs Date', key:'fat_date', cellMargin:1 },
 { label:'FATs Venue', key:'fat_venue', cellMargin:2 },
 { label:'QA Agency', key:'qa_agency', cellMargin:2 },

 { label:'Dispatch Clearance Date', key:'dispatch_clearance_date', cellMargin:1 },
 { label:'Dispatch Clearance By', key:'dispatch_clearance_by', cellMargin:2 },

 { label:'Comment / Justification', key:'final_offer', cellMargin:2 }
],
"tdf_018": [
  { label:'Prototype Delivery Date', key:'deliveryDate', cellMargin:1 },
 { label:'Installation/Commission Date', key:'prototypeDate', cellMargin:1 },
 { label:'Location Of Delivery', key:'delivery_location', cellMargin:2 }
],
"U-HAT": [
 { label:'HATs Date', key:'hat_date', cellMargin:1 },
 { label:'SATs Date', key:'sat_date', cellMargin:1 },
 { label:'Location', key:'location', cellMargin:2 },
 { label:'Platform', key:'platform', cellMargin:2 },
 { label:'Comment', key:'comment', cellMargin:2 }
],
"UET": [
 { label:'Comment', key:'comment', cellMargin:2 }
],
"Rev_014": [
 { label:'Trial Completion Date', key:'date', cellMargin:1 },
 { label:'Comment', key:'final_offer', cellMargin:2 }
],
"R_029": [
 { label:'Comment', key:'final_offer', cellMargin:2 }
],
"R_030": [
 { label:'Bulk Production Delivery Date', key:'delivery_date', cellMargin:1 },
 { label:'Bulk Production Installation/Commission Date', key:'installation_date', cellMargin:1 },
 { label:'Comment', key:'final_offer', cellMargin:2 }
],


}

export const makeI = {
  "T-IP": [
    { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
    { label: '2.2 How Is The Requirement Being Met Presently', key: 'requirement_met', cellMargin: 1 },
    { label: '3. Dual Use Technology', key: 'dual_technology', cellMargin: 1 },
    { label: '4.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'prototype_qty', cellMargin: 1 },
    { label: '4.2 Quantity Bulk (MoQ)', key: 'bulk_qty', cellMargin: 1 },
    { label: '5.1 For Development Of Prototype', key: 'development_cost', cellMargin: 1 },
    { label: '5.2 Unit Cost For Bulk Quantity(in INR)', key: 'unit_cost', cellMargin: 1 },
    { label: '5.3.1 Last Purchase Price(in INR)', key: 'lpp_cost', cellMargin: 1 },
    { label: '5.3.2 Last Purchase Year', key: 'lpp_year', cellMargin: 1 },
    { label: '5.3.3 In Case Similar Development Of The Product Has Been Undertaken Then savings To exchequer', key: 'development_prototype', cellMargin: 1 },
    { label: '5.3.4 POEV', key: 'poev', cellMargin: 1 },
    { label: '6.1 Advantage of availability of technology indigenously designed product', key: 'indigenously_designed', cellMargin: 2 },
    { label: '6.2 Avaialability of design capability and infrastructure in India', key: 'capability_infrastructure', cellMargin: 2 },
    { label: '6.3 Is the proposed system a part of Long Term Perspective Plan(LTPP)', key: 'ltpp', cellMargin: 2 },
    { label: '7. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
    { label: '8.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '9. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms)', key: 'rfi_indigenous', cellMargin: 2 },
    { label: '10. Details of any collaboration envisaged with foreign partner (If yes, details to be provided)', key: 'collaboration_envisaged', cellMargin: 2 },
    { label: '11. Confirmation that indigenisation is not being undertaken through DRDO/PSU or IA/IAF (If indigenisation has been attempted previously then the bottleneck that the present proposal aims to overcome)', key: 'drdo_psu', cellMargin: 2 },
    { label: '12. Details of technical specifications of the equipment/system', key: 'technical_specifications', cellMargin: 2 },
    { label: '13. Details of operational requirements of the equipment / Role of proposed item in overall operation strategy', key: 'operational_requirement', cellMargin: 2 },
    { label: '14. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
    { label: '15. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
    { label: '16. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan', key: 'annual_Acquisition', cellMargin: 2 },
    { label: '17. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
    { label: '18. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
    { label: '19. Any envisaged export potential of the equipment/system (For viability of the proposal to be taken under Make I category)', key: 'export_potential', cellMargin: 2 },
    { label: '20.1 Description of critical technology required', key: 'critical_technology', cellMargin: 2 },
    { label: '20.2 Infrastructure required/Available with DRDO/Services/PSU', key: 'drdo_infrastructure', cellMargin: 2 },
    { label: '20.3 Infrastructure required for trials', key: 'trial_infrastructure', cellMargin: 2 },
    { label: '21. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.', key: 'project_similar', cellMargin: 2 },
    { label: '22. Approval and priority from APSO concerned for case under Make I category', key: 'approval_apso', cellMargin: 2 },
    { label: '23. Details of nodal officer execute the project through the Capital Route under MAKE I category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },

  ],
  // "makeI_02": [
  //   { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
  //   { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
  //   { label: '2.2 How Is The Requirement Being Met Presently', key: 'requirement_met', cellMargin: 1 },
  //   { label: '3. Dual Use Technology', key: 'dual_technology', cellMargin: 1 },
  //   { label: '4.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'qtyPrototype', cellMargin: 1 },
  //   { label: '4.2 Quantity Bulk (MoQ)', key: 'qtyBulk', cellMargin: 1 },
  //   { label: '5.1 For Development Of Prototype', key: 'estimatedCost', cellMargin: 1 },
  //   { label: '5.2 Unit Cost For Bulk Quantity(in INR)', key: 'estimatedUnitCost', cellMargin: 1 },
  //   { label: '5.3.1 Last Purchase Price(in INR)', key: 'llp', cellMargin: 1 },
  //   { label: '5.3.2 Last Purchase Year', key: 'lpyear', cellMargin: 1 },
  //   { label: '5.3.3 In Case Similar Development Of The Product Has Been Undertaken Then savings To exchequer', key: 'development_prototype', cellMargin: 1 },
  //   { label: '5.3.4 POEV', key: 'poev', cellMargin: 1 },
  //   { label: '6.1 Advantage of availability of technology indigenously designed product', key: 'indigenously_designed', cellMargin: 2 },
  //   { label: '6.2 Avaialability of design capability and infrastructure in India', key: 'capability_infrastructure', cellMargin: 2 },
  //   { label: '6.3 Is the proposed system a part of Long Term Perspective Plan(LTPP)', key: 'ltpp', cellMargin: 2 },
  //   { label: '7. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
  //   { label: '8.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
  //   { label: '9. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms)', key: 'rfi_indigenous', cellMargin: 2 },
  //   { label: '10. Details of any collaboration envisaged with foreign partner (If yes, details to be provided)', key: 'collaboration_envisaged', cellMargin: 2 },
  //   { label: '11. Confirmation that indigenisation is not being undertaken through DRDO/PSU or IA/IAF (If indigenisation has been attempted previously then the bottleneck that the present proposal aims to overcome)', key: 'drdo_psu', cellMargin: 2 },
  //   { label: '12. Details of technical specifications of the equipment/system', key: 'technical_specifications', cellMargin: 2 },
  //   { label: '13. Details of operational requirements of the equipment / Role of proposed item in overall operation strategy', key: 'operationalRequirements', cellMargin: 2 },
  //   { label: '14. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
  //   { label: '15. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
  //   { label: '16. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan', key: 'annual_Acquisition', cellMargin: 2 },
  //   { label: '17. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
  //   { label: '18. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
  //   { label: '19. Any envisaged export potential of the equipment/system (For viability of the proposal to be taken under Make I category)', key: 'export_potential', cellMargin: 2 },
  //   { label: '20.1 Description of critical technology required', key: 'critical_technology', cellMargin: 2 },
  //   { label: '20.2 Infrastructure required/Available with DRDO/Services/PSU', key: 'drdo_infrastructure', cellMargin: 2 },
  //   { label: '20.3 Infrastructure required for trials', key: 'trial_infrastructure', cellMargin: 2 },
  //   { label: '21. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.', key: 'project_similar', cellMargin: 2 },
  //   { label: '22. Approval and priority from APSO concerned for case under Make I category', key: 'approval_apso', cellMargin: 2 },
  //   { label: '23. Details of nodal officer execute the project through the Capital Route under MAKE I category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },

  // ],
  "makeI_02":[],
  "A-VCNS": [
    { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "C-EA": [],
  "R-AIP": [
    { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "R-MOM": [
    { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "PFT":[],
  "P_QR":[
    { label: 'Questionnaire', key: 'questionnaireContent', cellMargin: 2 },
  ],
  "makeI_06":[
    { label: 'Feasibility Study From', key: 'comment', cellMargin: 2 },
  ],
  "makeI_07":[
  { label: 'Introduction', key: 'introduction' },
  { label: 'Essential Parameters A', key: 'essential_parameter_a' , cellMargin: 2},
  { label: 'Section A Operational Parameters', key: 'operational_parameters', cellMargin: 2 },
  { label: 'Section B Technical Parameters', key: 'technical_parameters', cellMargin: 2 },
  { label: 'Section C Maintainability and Ergonomic Parameters', key: 'maintainability_ergonomic_parameters', cellMargin: 2 },
  { label: 'Essential Parameters B', key: 'essential_parameter_b', cellMargin: 2 },
  { label: 'Enhanced Performance Parameters', key: 'enhanced_performance_parameters', cellMargin: 2 },
  { label: 'SQR Content', key: 'sqr_content', cellMargin: 2 },

  ],
  "makeI_08":[
  { label: 'SOC Content', key: 'socContent', cellMargin: 2 },
  { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "AC-AON":[],
  "P-EOIPDD":[
    { label: 'Expression of Interest (EoI)', key: 'comment', cellMargin: 2 },
    { label: 'PDD', key: 'comment_2', cellMargin: 2 },
  ],
  "I-EOI":[],
  "P-EOI":[
    { label: 'Pre EOI Meeting & Vendor Queries/Response Justification', key: 'pre_bid', cellMargin: 2 },
  ],
  "E-RDPR":[],
  "R-UEOID":[],
  "S-DAVCNS":[],
  "M-RFP":[
  { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "I-LRFP":[],
  "R-TN":[
  { label: 'Justification', key: 'comment', cellMargin: 2 },
  ],
  "makeI_23":[
  { label: 'Essential Parameters', key: 'essential_parameter', cellMargin: 2 },
  { label: 'Desirable Parameters', key: 'desirable_parameter', cellMargin: 2 },
  { label: 'Functional Requirements', key: 'functional_req', cellMargin: 2 },
  { label: 'Performance Requirements', key: 'performance_req', cellMargin: 2 },
  { label: 'Technical Requirements', key: 'technical_req', cellMargin: 2 },
  { label: 'Operational Requirements', key: 'operational_req', cellMargin: 2 },
  { label: 'Logistical Requirements', key: 'logistical_req', cellMargin: 2 },
  { label: 'Cost Requirements', key: 'cost_req', cellMargin: 2 },
  { label: 'Timeline Requirements', key: 'timeline_req', cellMargin: 2 },
  { label: 'Additional Requirements', key: 'additional_req', cellMargin: 2 },
  { label: 'Justification', key: 'justification', cellMargin: 2 },

   ],

   "R-BM":[
  { label: 'Technical Bid Opening Date', key: 'bid_opening_date', cellMargin: 1 },
  { label: 'Technical Bid Opening Time', key: 'bid_opening_time', cellMargin: 1 },
  { label: 'Technical Bid Opening Venue', key: 'bid_opening_venue', cellMargin: 1 },
  { label: 'Benchmark Price', key: 'benchmark_price', cellMargin: 1 },
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],

   "Q-CST":[
  { label: 'Q-Bid Opening Date', key: 'qbid_date', cellMargin: 1 },
  { label: 'Time', key: 'qbid_time', cellMargin: 1 },
  { label: 'Venue', key: 'qbid_venue', cellMargin: 1 },
  { label: 'CST Approval Date', key: 'cst_approval', cellMargin: 1 },
  { label: 'Commercial Bid Opening Sheet', key: 'commercialSheetEditorData', cellMargin: 2 },
  { label: 'CST Sheet', key: 'cstSheetEditorData', cellMargin: 2 },
  { label: 'Benchmark Price', key: 'benchmark', cellMargin: 1 },
  { label: 'Comments', key: 'comment', cellMargin: 1 },
   ],

  "R-FO":[
  { label: 'IFA/MoD Concurrence Date', key: 'installation_date', cellMargin: 1 },
  { label: 'CFA Approval Date', key: 'delivery_date', cellMargin: 1 },
  { label: 'Final Cost (INR)', key: 'final_cost', cellMargin: 1 },
  { label: 'TEC table', key: 'tec_table', cellMargin: 2 },
  { label: 'Justification', key: 'final_offer', cellMargin: 2 },
   ],
   "F-IPSO": [
  { label: 'Comment', key: 'sanction_order', cellMargin: 2 },
   ],
   "Rev_011":[
  { label: 'Final Date of Approved Documents', key: 'date', cellMargin: 1 },
  { label: 'Delivery Date of Prototype System', key: 'qap_date', cellMargin: 1 },
  { label: 'Comments', key: 'comment', cellMargin: 2 },
   ],
   "idex_007":[],
   "make1_009":[
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],

   "makeI_29":[
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],
   "I-RFP":[
  { label: 'Remarks', key: 'comment', cellMargin: 2 },
   ],
   "make1_001":[
  { label: 'Remarks', key: 'comment', cellMargin: 2 },
   ],
   "tdf_006":[
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],
   "M-SC":[
  { label: 'Comment', key: 'sanction_order', cellMargin: 2 },
   ],

   "R_029":[
  { label: 'Comment', key: 'final_offer', cellMargin: 2 },
  { label: 'Clearance from Professional Dte for BPC Date', key: 'deliveryDate', cellMargin: 1 },
   ],

}

export const makeII = {
  "I-SP": [
    { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
    { label: '2.2 How Is The Requirement Being Met Presently', key: 'requirement_met', cellMargin: 1 },
    { label: '3.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'prototype_qty', cellMargin: 1 },
    { label: '3.2 Quantity Bulk (MoQ)', key: 'bulk_qty', cellMargin: 1 },
    { label: '4.1 For Development Of Prototype', key: 'development_cost', cellMargin: 1 },
    { label: '4.2 Unit Cost For Bulk Quantity(in INR)', key: 'unit_cost', cellMargin: 1 },
    { label: '4.3.1 LPP / Similar Development', key: 'lpp_cost', cellMargin: 1 },
    { label: '5.1 Advantage of availability of technology indigenously designed product', key: 'indigenously_designed', cellMargin: 2 },
    { label: '6. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
    { label: '7.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '8. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms) / Details of any collaboration with foreign OEM envisaged', key: 'rfi_indigenous', cellMargin: 2 },
    { label: '9. Confirmation that indigenisation is not being undertaken through DRDO/PSU', key: 'drdo_psu', cellMargin: 2 },
    { label: '10. Details of technical specifications of the equipment/system / Role of the proposed item/ system in overall operational strategy', key: 'technical_specifications', cellMargin: 2 },
    { label: '11. Details of operational requirements of the equipment', key: 'operational_requirement', cellMargin: 2 },
    { label: '12. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
    { label: '13. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
    { label: '14. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan', key: 'annual_Acquisition', cellMargin: 2 },
    { label: '15. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
    { label: '16. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
    { label: '17. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.', key: 'project_similar', cellMargin: 2 },
    { label: '18. Details of nodal officer execute the project through the Capital Route under MAKE II category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },
    { label: '19. Approval and priority from APSO concerned for case under Make II category', key: 'approval_apso', cellMargin: 2 },
    { label: '20. Is Item under Revenue/iDEX procurement?', key: 'revenue_idex', cellMargin: 2 },
  ],
  "makeI_02": [
  ],
 
  "A-VCNS": [
    { label: 'Remarks', key: 'justification', cellMargin: 1 },
  ],
  "C-EA": [],
  "R-AIP": [
    { label: 'Remarks', key: 'comment', cellMargin: 1 },
  ],
  "R-MOM": [
    { label: 'Remarks', key: 'justification', cellMargin: 1 },
  ],
  "PFT":[],
  "P_QR":[
    { label: 'Questionnaire', key: 'questionnaireContent', cellMargin: 2 },
  ],
  "makeI_06":[
    { label: 'Feasibility Study From', key: 'comment', cellMargin: 2 },
  ],
  "makeI_07":[
  { label: 'SQR Content', key: 'introduction', cellMargin: 2 },

  ],
  "makeI_08":[
  { label: 'SOC Content', key: 'soc_content', cellMargin: 2 },
  { label: 'Remarks', key: 'comment', cellMargin: 1 },
  ],
  "AC-AON":[],
  "P-EOIPDD":[
    { label: 'Expression of Interest (EoI)', key: 'comment', cellMargin: 2 },
    { label: 'PDD', key: 'comment_2', cellMargin: 2 },
  ],
  "I-EOI":[],
  "P-EOI":[
    { label: 'Pre EOI Meeting & Vendor Queries/Response Justification', key: 'pre_bid', cellMargin: 2 },
  ],
  "E-RDPR":[],
  "R-UEOID":[],
  "S-DAVCNS":[],
  "F-IPSO":[],
  "Rev_011":[
  { label: 'Final Date of Approved Documents', key: 'date', cellMargin: 1 },
  { label: 'Delivery Date of Prototype System', key: 'qap_date', cellMargin: 1 },
  { label: 'Comments', key: 'comment', cellMargin: 2 },
   ],
   "idex_007":[],
   "make1_009":[ 
  { label: 'Justification', key: 'justification', cellMargin: 2 },
   ],
   "makeI_29":[
  { label: 'Justification', key: 'justification', cellMargin: 2 },
   ],

   "makeI_23":[ 

  { label: 'Justification', key: 'justification', cellMargin: 2 },

   ],
   "M-RFP":[
  { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "I-LRFP":[],
   "make1_001":[ 
  { label: 'Remarks', key: 'comment', cellMargin: 2 },
   ],
    "R-BM":[
  { label: 'Technical Bid Opening Date', key: 'bid_opening_date', cellMargin: 1 },
  { label: 'Technical Bid Opening Time', key: 'bid_opening_time', cellMargin: 1 },
  { label: 'Technical Bid Opening Venue', key: 'bid_opening_venue', cellMargin: 1 },
  { label: 'Benchmark Price', key: 'benchmark_price', cellMargin: 1 },
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],
   "R-FO":[
  { label: 'IFA/MoD Concurrence Date', key: 'installation_date', cellMargin: 1 },
  { label: 'CFA Approval Date', key: 'delivery_date', cellMargin: 1 },
  { label: 'Final Cost (INR)', key: 'final_cost', cellMargin: 1 },
  { label: 'TEC table', key: 'tec_table', cellMargin: 2 },
  { label: 'Justification', key: 'final_offer', cellMargin: 2 },
   ],
"M-SC":[
  { label: 'Comment', key: 'draft_rfp', cellMargin: 2 },
   ],

    "I-SPROP": [
    { label: '1. Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
    { label: '3.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'prototype_qty', cellMargin: 1 },
    { label: '3.2 Quantity Bulk (MoQ)', key: 'bulk_qty', cellMargin: 1 },
    { label: '4.1 For Development Of Prototype', key: 'development_cost', cellMargin: 1 },
    { label: '4.2 Unit Cost For Bulk Quantity(in INR)', key: 'unit_cost', cellMargin: 1 },
    { label: '4.3.1 Last Purchase Price(in INR)', key: 'lpp_cost', cellMargin: 1 },
    { label: '5.1 Item already held in Inventory requiring Import substitution', key: 'indigenously_designed', cellMargin: 2 },
    { label: '5.2 Cost effectiveness', key: 'capability_infrastructure', cellMargin: 2 },
    { label: '5.3 Lead Time', key: 'ltpp', cellMargin: 2 },
    { label: '6. Vintage and OEM', key: 'vinatge_oem', cellMargin: 2 },
    { label: '7. Requirement of indigenizing existing equipment view obsolescence or upgradation or replacement', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '8. Details of RFI undertaken with date for the same and responses therein', key: 'rfi_indigenous', cellMargin: 2 },
    { label: '9.1 Confirmation from at least one known MSME or vendor that the equipment/system can be developed and manufactured in India as per design of OEM with minimum 60% Indigenous Content', key: 'collaboration_envisaged', cellMargin: 2 },
    { label: '10. Confirmation of at least one Indian Entity/Firm ready to undertake JV/ToT with the Foreign OEM', key: 'drdo_psu', cellMargin: 2 },
    { label: '11. Details of technical specifications of the equipment/ system/ spare', key: 'technical_specifications', cellMargin: 2 },
    { label: '12.  Details of operational requirements of the equipment/system/spare', key: 'operational_requirement', cellMargin: 2 },
    { label: '13. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
    { label: '14. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
    { label: '15. Confirmation if project is included in Annual Acquisition Plan', key: 'annual_Acquisition', cellMargin: 2 },
    { label: '16. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
    { label: '17. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
    { label: '18. Confirmation that the indigenization is not being undertaken through DRDO/PSU', key: 'project_similar', cellMargin: 2 },
    { label: '19. Details of nodal officer execute the project through the Capital Route under MAKE III category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },
    { label: '20. Approval and priority from APSO concerned for case under Make III category', key: 'approval_apso', cellMargin: 2 },
  ],





}


export const makeIII = {
  "I-SPROP": [
    { label: '1. Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
    { label: '3.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'qtyPrototype', cellMargin: 1 },
    { label: '3.2 Quantity Bulk (MoQ)', key: 'qtyBulk', cellMargin: 1 },
    { label: '4.1 For Development Of Prototype', key: 'estimatedCost', cellMargin: 1 },
    { label: '4.2 Unit Cost For Bulk Quantity(in INR)', key: 'estimatedUnitCost', cellMargin: 1 },
    { label: '4.3.1 Last Purchase Price(in INR)', key: 'llp', cellMargin: 1 },
    { label: '5.1 Item already held in Inventory requiring Import substitution', key: 'development_prototype', cellMargin: 2 },
    { label: '5.2 Cost effectiveness', key: 'estimatedUnitCost', cellMargin: 2 },
    { label: '5.3 Lead Time', key: 'ltpp', cellMargin: 2 },
    { label: '6. Vintage and OEM', key: 'lead_development', cellMargin: 2 },
    { label: '7. Requirement of indigenizing existing equipment view obsolescence or upgradation or replacement', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '8. Details of RFI undertaken with date for the same and responses therein', key: 'rfi_indigenous', cellMargin: 2 },
    { label: '9.1 Confirmation from at least one known MSME or vendor that the equipment/system can be developed and manufactured in India as per design of OEM with minimum 60% Indigenous Content', key: 'collaboration_envisaged', cellMargin: 2 },
    { label: '10. Confirmation of at least one Indian Entity/Firm ready to undertake JV/ToT with the Foreign OEM', key: 'drdo_psu', cellMargin: 2 },
    { label: '11. Details of technical specifications of the equipment/ system/ spare', key: 'technical_specifications', cellMargin: 2 },
    { label: '12.  Details of operational requirements of the equipment/system/spare', key: 'operationalRequirements', cellMargin: 2 },
    { label: '13. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
    { label: '14. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
    { label: '15. Confirmation if project is included in Annual Acquisition Plan', key: 'annual_Acquisition', cellMargin: 2 },
    { label: '16. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
    { label: '17. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
    { label: '18. Confirmation that the indigenization is not being undertaken through DRDO/PSU', key: 'project_similar', cellMargin: 2 },
    { label: '19. Details of nodal officer execute the project through the Capital Route under MAKE III category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },
    { label: '20. Approval and priority from APSO concerned for case under Make III category', key: 'approval_apso', cellMargin: 2 },
  ],
  "makeI_02": [
    { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
    { label: '2.2 How Is The Requirement Being Met Presently', key: 'requirement_met', cellMargin: 1 },
    { label: '3.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'qtyPrototype', cellMargin: 1 },
    { label: '3.2 Quantity Bulk (MoQ)', key: 'qtyBulk', cellMargin: 1 },
    { label: '4.1 For Development Of Prototype', key: 'estimatedCost', cellMargin: 1 },
    { label: '4.2 Unit Cost For Bulk Quantity(in INR)', key: 'estimatedUnitCost', cellMargin: 1 },
    { label: '4.3.1 Last Purchase Price(in INR)', key: 'llp', cellMargin: 1 },
    { label: '5.1 Advantage of availability of technology indigenously designed product', key: 'indigenously_designed', cellMargin: 2 },
    { label: '6. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
    { label: '7.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '8. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms) / Details of any collaboration with foreign OEM envisaged', key: 'rfi_indigenous', cellMargin: 2 },
    { label: '6.2 Avaialability of design capability and infrastructure in India', key: 'capability_infrastructure', cellMargin: 2 },
    { label: '6.3 Is the proposed system a part of Long Term Perspective Plan(LTPP)', key: 'ltpp', cellMargin: 2 },
    { label: '7. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
    { label: '8.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '9. Confirmation that indigenisation is not being undertaken through DRDO/PSU', key: 'drdo_psu', cellMargin: 2 },
    { label: '10. Details of technical specifications of the equipment/system / Role of the proposed item/ system in overall operational strategy', key: 'technical_specifications', cellMargin: 2 },
    { label: '11. Details of operational requirements of the equipment', key: 'operationalRequirements', cellMargin: 2 },
    { label: '12. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
    { label: '13. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
    { label: '14. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan', key: 'annual_Acquisition', cellMargin: 2 },
    { label: '15. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
    { label: '16. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
    { label: '17. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.', key: 'project_similar', cellMargin: 2 },
    { label: '18. Details of nodal officer execute the project through the Capital Route under MAKE II category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },
    { label: '19. Approval and priority from APSO concerned for case under Make II category', key: 'approval_apso', cellMargin: 2 },
    { label: '20. Is Item under Revenue/iDEX procurement?', key: 'critical_technology', cellMargin: 2 },
  ],
 
  "A-VCNS": [
      { label: 'Nomenclature', key: 'nomenclature', cellMargin: 1 },
    { label: '2.1 Brief Description With Technical Details.', key: 'brief_description', cellMargin: 1 },
    { label: '2.2 How Is The Requirement Being Met Presently', key: 'requirement_met', cellMargin: 1 },
    { label: '3.1 Quantity Prototype (based on acceptance criteria and tests)', key: 'qtyPrototype', cellMargin: 1 },
    { label: '3.2 Quantity Bulk (MoQ)', key: 'qtyBulk', cellMargin: 1 },
    { label: '4.1 For Development Of Prototype', key: 'estimatedCost', cellMargin: 1 },
    { label: '4.2 Unit Cost For Bulk Quantity(in INR)', key: 'estimatedUnitCost', cellMargin: 1 },
    { label: '4.3.1 Last Purchase Price(in INR)', key: 'llp', cellMargin: 1 },
    { label: '5.1 Advantage of availability of technology indigenously designed product', key: 'indigenously_designed', cellMargin: 2 },
    { label: '6. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
    { label: '7.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '8. Details of RFI/Market survey undertaken with date and responses therein / whether indigenous capability exists (List of prospective firms) / Details of any collaboration with foreign OEM envisaged', key: 'rfi_indigenous', cellMargin: 2 },
    { label: '6.2 Avaialability of design capability and infrastructure in India', key: 'capability_infrastructure', cellMargin: 2 },
    { label: '6.3 Is the proposed system a part of Long Term Perspective Plan(LTPP)', key: 'ltpp', cellMargin: 2 },
    { label: '7. Expected Lead Time for Prototype Development', key: 'lead_development', cellMargin: 2 },
    { label: '8.1 In view of obsolescence/ upgradtion/ replacement/ import substitution / new induction to counter emerging threat perception', key: 'indigenise_equipment', cellMargin: 2 },
    { label: '9. Confirmation that indigenisation is not being undertaken through DRDO/PSU', key: 'drdo_psu', cellMargin: 2 },
    { label: '10. Details of technical specifications of the equipment/system / Role of the proposed item/ system in overall operational strategy', key: 'technical_specifications', cellMargin: 2 },
    { label: '11. Details of operational requirements of the equipment', key: 'operationalRequirements', cellMargin: 2 },
    { label: '12. Availability of drawings/manuals/technical documentation', key: 'drawings_manuals', cellMargin: 2 },
    { label: '13. Availability of sample for indigenisation (if required)', key: 'sample_indigenisation', cellMargin: 2 },
    { label: '14. Confirmation if project is included in Annual Acquisition Plan / Long Term Perspective Plan', key: 'annual_Acquisition', cellMargin: 2 },
    { label: '15. List and venue of likely trials and environmental tests / Type IAW MIL or other standards', key: 'trials_environments', cellMargin: 2 },
    { label: '16. Availability of photograph of item', key: 'photograph_item', cellMargin: 2 },
    { label: '17. Details of projects similar projects being undertaken by IA/IAF/DRDO or through Capital route / D&D / iDEX / TDF / Revenue route and progress report of such cases if any/any similar system already existing in the inventory.', key: 'project_similar', cellMargin: 2 },
    { label: '18. Details of nodal officer execute the project through the Capital Route under MAKE II category from user Dte.', key: 'nodal_officer_details', cellMargin: 2 },
    { label: '19. Approval and priority from APSO concerned for case under Make II category', key: 'approval_apso', cellMargin: 2 },
    { label: '20. Is Item under Revenue/iDEX procurement?', key: 'critical_technology', cellMargin: 2 },
    { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "C-EA": [],
  "R-AIP": [
    { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "R-MOM": [
    { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "PFT":[],
  "P_QR":[
    { label: 'Questionnaire', key: 'questionnaireContent', cellMargin: 2 },
  ],
  "makeI_06":[
    { label: 'Feasibility Study From', key: 'comment', cellMargin: 2 },
  ],
  "makeI_07":[
  { label: 'Introduction', key: 'introduction' },
  { label: 'Essential Parameters A', key: 'essential_parameter_a' , cellMargin: 2},
  { label: 'Section A Operational Parameters', key: 'operational_parameters', cellMargin: 2 },
  { label: 'Section B Technical Parameters', key: 'technical_parameters', cellMargin: 2 },
  { label: 'Section C Maintainability and Ergonomic Parameters', key: 'maintainability_ergonomic_parameters', cellMargin: 2 },
  { label: 'Essential Parameters B', key: 'essential_parameter_b', cellMargin: 2 },
  { label: 'Enhanced Performance Parameters', key: 'enhanced_performance_parameters', cellMargin: 2 },
  { label: 'SQR Content', key: 'sqr_content', cellMargin: 2 },

  ],
  "makeI_08":[
  { label: 'SOC Content', key: 'socContent', cellMargin: 2 },
  { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "AC-AON":[],
  "P-EOIPDD":[
    { label: 'Expression of Interest (EoI)', key: 'comment', cellMargin: 2 },
    { label: 'PDD', key: 'comment_2', cellMargin: 2 },
  ],
  "I-EOI":[],
  "P-EOI":[
    { label: 'Pre EOI Meeting & Vendor Queries/Response Justification', key: 'pre_bid', cellMargin: 2 },
  ],
  "E-RDPR":[],
  "R-UEOID":[],
  "S-DAVCNS":[],
  "F-IPSO":[],
  "Rev_011":[
  { label: 'Final Date of Approved Documents', key: 'date', cellMargin: 1 },
  { label: 'Delivery Date of Prototype System', key: 'qap_date', cellMargin: 1 },
  { label: 'Comments', key: 'comment', cellMargin: 2 },
   ],
   "idex_007":[],
   "make1_009":[ 
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],
   "makeI_29":[
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],

   "makeI_23":[ 
  { label: 'Essential Parameters', key: 'essential_parameter', cellMargin: 2 },
  { label: 'Desirable Parameters', key: 'desirable_parameter', cellMargin: 2 },
  { label: 'Functional Requirements', key: 'functional_req', cellMargin: 2 },
  { label: 'Performance Requirements', key: 'performance_req', cellMargin: 2 },
  { label: 'Technical Requirements', key: 'technical_req', cellMargin: 2 },
  { label: 'Operational Requirements', key: 'operational_req', cellMargin: 2 },
  { label: 'Logistical Requirements', key: 'logistical_req', cellMargin: 2 },
  { label: 'Cost Requirements', key: 'cost_req', cellMargin: 2 },
  { label: 'Timeline Requirements', key: 'timeline_req', cellMargin: 2 },
  { label: 'Additional Requirements', key: 'additional_req', cellMargin: 2 },
  { label: 'Justification', key: 'justification', cellMargin: 2 },

   ],
   "M-RFP":[
  { label: 'Remarks', key: 'remark', cellMargin: 1 },
  ],
  "I-LRFP":[],
   "make1_001":[ 
  { label: 'Remarks', key: 'comment', cellMargin: 2 },
   ],
    "R-BM":[
  { label: 'Technical Bid Opening Date', key: 'bid_opening_date', cellMargin: 1 },
  { label: 'Technical Bid Opening Time', key: 'bid_opening_time', cellMargin: 1 },
  { label: 'Technical Bid Opening Venue', key: 'bid_opening_venue', cellMargin: 1 },
  { label: 'Benchmark Price', key: 'benchmark_price', cellMargin: 1 },
  { label: 'Justification', key: 'comment', cellMargin: 2 },
   ],
   "R-FO":[
  { label: 'IFA/MoD Concurrence Date', key: 'installation_date', cellMargin: 1 },
  { label: 'CFA Approval Date', key: 'delivery_date', cellMargin: 1 },
  { label: 'Final Cost (INR)', key: 'final_cost', cellMargin: 1 },
  { label: 'TEC table', key: 'tec_table', cellMargin: 2 },
  { label: 'Justification', key: 'final_offer', cellMargin: 2 },
   ],
"M-SC":[
  { label: 'Comment', key: 'sanction_order', cellMargin: 2 },
   ],


}

export const idex: any = {

  // ✅ COMMON CHALLENGE STRUCTURE (FIXED)
  idex_001: [
    { label: 'Challenge Name', key: 'title', cellMargin: 1 },
    { label: 'Category', key: 'category', cellMargin: 1 },
    { label: 'Monitoring Organisation', key: 'organisation', cellMargin: 1 },
    { label: 'Nodal Directorate (Procurement)', key: 'nodal_precurement', cellMargin: 1 },
    { label: 'Nodal Directorate (Development & Trial)', key: 'coordinated_agency', cellMargin: 1 },
    { label: 'Nodal Officer', key: 'nodal_officer', cellMargin: 1 },
    { label: 'Release Date', key: 'release_date', cellMargin: 1 },
    { label: 'Technology Domain', key: 'technology_domain', cellMargin: 1 },

    { label: 'Problem Statement', key: 'problem_statement', cellMargin: 1 },
    { label: 'Challenge Brief', key: 'challenge_brief', cellMargin: 1 },
    { label: 'Prototype Development', key: 'prototype_development', cellMargin: 1 },
    { label: 'Requirement', key: 'requirement', cellMargin: 1 },

    { label: 'IP Value', key: 'ip_value', cellMargin: 1 }, // ✅ only once
    { label: 'Functional Advantages', key: 'functional_advantages', cellMargin: 1 },
    { label: 'Domestic Capability', key: 'domestic', cellMargin: 1 },
    { label: 'Import Substitution', key: 'substitution', cellMargin: 1 },

    { label: 'Preliminary Scope', key: 'preliminary_scope', cellMargin: 1 },
    { label: 'Competitive Solution', key: 'competitive_solution', cellMargin: 1 },
    { label: 'Potential Market', key: 'potential_market', cellMargin: 1 },
    { label: 'Risk Assessment', key: 'risk_assessment', cellMargin: 1 },
    { label: 'MPQ', key: 'mpo_qty', cellMargin: 1 },
    { label: 'IP Value', key: 'ip_value', cellMargin: 1 }

  ],

  // ✅ SAFE ALIAS (reuse structure)
  'I-SC': 'idex_001',
  'C-APPR': 'idex_001',

  // ✅ IP VALUE (separate section if needed)
  // IPV: [
  //   { label: 'IP Value', key: 'ip_value', cellMargin: 1 }
  // ],

  // ✅ VENDOR TABLE
 'I-UP': [
  // { label: 'Sr No', key: 'sr_no', cellMargin: 1 },
  // { label: 'Name', key: 'name', cellMargin: 1 },
  // { label: 'Company', key: 'company_name', cellMargin: 1 },
  // { label: 'Email', key: 'email', cellMargin: 1 },
  // { label: 'Phone', key: 'phone_number', cellMargin: 1 },
  // { label: 'Status', key: 'vendor_status', cellMargin: 1 },
  // { label: 'Applying As', key: 'applying_as', cellMargin: 1 },
  // { label: 'Technology', key: 'technology', cellMargin: 1 },
  // { label: 'Domain', key: 'themenetic', cellMargin: 1 },
  // { label: 'City', key: 'city', cellMargin: 1 },
  // { label: 'State', key: 'states', cellMargin: 1 },
  // { label: 'Agency 1', key: 'agencie_1', cellMargin: 1 },
  // { label: 'Recommendation 1', key: 'recommendations_1', cellMargin: 1 },
  // { label: 'Comments 1', key: 'comments_1', cellMargin: 1 },
  // { label: 'Agency 2', key: 'agencie_2', cellMargin: 1 },
  // { label: 'Recommendation 2', key: 'recommendations_2', cellMargin: 1 },
  // { label: 'Comments 2', key: 'comments_2', cellMargin: 1 },
  // { label: 'Agency 3', key: 'agencie_3', cellMargin: 1 },
  // { label: 'Recommendation 3', key: 'recommendations_3', cellMargin: 1 },
  // { label: 'Comments 3', key: 'comments_3', cellMargin: 1 }
],
  // ✅ COMMITTEE
  idex_004: [
    { label: 'Committee Code', key: 'code', cellMargin: 1 },
    { label: 'Status', key: 'status', cellMargin: 1 },
    { label: 'Created On', key: 'created_on', cellMargin: 1 }
  ],

  // ⚠️ EMPTY (NO API DATA)
  idex_005: [],
  'I-UPS': [],
  'I-TE': [],

  // ✅ BUDGET
  'I-UDA': [
    { label: 'Development Budget', key: 'development_budget', cellMargin: 1 }
  ],

  // ✅ MILESTONES
  MS00: [
    { label: 'Amount', key: 'amount', cellMargin: 1 },
    { label: 'Date', key: 'date', cellMargin: 1 }
  ],
  MS01: 'MS00',
  MS02: 'MS00',
  MS03: 'MS00',
  MS04: 'MS00',
  MS05: 'MS00',

  // ✅ JUSTIFICATION
  makeI_23: [
    { label: 'Justification', key: 'justification', cellMargin: 1 }
  ],

  // ✅ AON
  AoNSoC: [
    { label: 'AON Date', key: 'aon_date', cellMargin: 1 },
    { label: 'AON Quantity', key: 'aon_qty', cellMargin: 1 },
    { label: 'AON Cost', key: 'aon_cost', cellMargin: 1 }
  ]
};

export const oc = {

  // ✅ Upload Challenges
 "U-PC": [
  { label: 'Name', key: 'name' },
  { label: 'Recommended By', key: 'recommended_by' },
  { label: 'Status', key: 'status' },
  { label: 'Category', key: 'category' },
  { label: 'Challenge Status', key: 'challenge_status' },
  { label: 'Challenge No', key: 'challenge_number' },
  { label: 'Sr No', key: 'sr_no' },

  { label: 'Applying As', key: 'applying_as' },
  { label: 'Technology', key: 'technology' },
  { label: 'Thematic OC', key: 'themenetic' },

  { label: 'Phone Number', key: 'phone_number' },
  { label: 'Email', key: 'email' },
  { label: 'State', key: 'states' },
  { label: 'City', key: 'city' },
  { label: 'Address', key: 'address' },

  { label: 'Company Name', key: 'company_name' },
  { label: 'Company Website', key: 'company_website' },
  { label: 'Company Portfolio', key: 'company_portfolio' },

  { label: 'Innovation Title', key: 'innovation_title' },
  { label: 'Title of Innovation', key: 'title_innovative' },

  { label: 'Designation', key: 'designation_applicant' },
  { label: 'Nodal Directorate', key: 'nodal_dte' },

  { label: 'TRRT Recommendation', key: 'recommendations_1' },
  { label: 'TRRT Comments', key: 'comments_1' },

  { label: 'BGH Recommendation', key: 'recommendations_2' },
  { label: 'BGH Comments', key: 'comments_2' },

  { label: 'OH Recommendation', key: 'recommendations_3' },
  { label: 'OH Comments', key: 'comments_3' },

  { label: 'Brief', key: 'brief' }
],

  // ✅ Screening Applications (vendors array)
  "SCR-APP": [
  { label: 'Name', key: 'name' },
  { label: 'Company Name', key: 'company_name' },
  { label: 'Email', key: 'email' },
  { label: 'Phone Number', key: 'phone_number' },

  { label: 'Sr No', key: 'sr_no' },
  { label: 'Challenge No', key: 'challenge_number' },

  { label: 'Applying As', key: 'applying_as' },
  { label: 'Technology', key: 'technology' },
  { label: 'Thematic OC', key: 'themenetic' },

  { label: 'State', key: 'states' },
  { label: 'City', key: 'city' },
  { label: 'Address', key: 'address' },

  { label: 'Innovation Title', key: 'innovation_title' },
  { label: 'Title of Innovation', key: 'title_innovative' },

  { label: 'Company Website', key: 'company_website' },
  { label: 'Company Portfolio', key: 'company_portfolio' },

  { label: 'Designation', key: 'designation_applicant' },

  { label: 'TRRT Recommendation', key: 'recommendations_1' },
  { label: 'TRRT Comments', key: 'comments_1' },

  { label: 'BGH Recommendation', key: 'recommendations_2' },
  { label: 'BGH Comments', key: 'comments_2' },

  { label: 'OH Recommendation', key: 'recommendations_3' },
  { label: 'OH Comments', key: 'comments_3' }
],

  // ✅ Shortlisting of Challenge
  "S-C": [
    { label: 'Challenge ID', key: 'challenge' },
    { label: 'Code', key: 'code' },
    { label: 'Status', key: 'status' },
    { label: 'Justification', key: 'justification' }
  ],

  // ✅ VCNS Approved Challenges
  "C-APPR": [],

  // ✅ HPSC Committee
  "idex_004": [
    { label: 'Code', key: 'code' },
    { label: 'Status', key: 'status' },
    { label: 'File', key: 'file' }
  ],

  // ✅ Evaluation
  "idex_005": [],

  // ✅ Upload PDS
  "I-UPS": [
    { label: 'Code', key: 'code' },
    { label: 'Status', key: 'status' }
  ],

  // ✅ Upload Technical Docs
  "I-TE": [
    { label: 'Code', key: 'code' },
    { label: 'Status', key: 'status' },
    { label: 'Remark', key: 'remark' }
  ],

  // ✅ WBS & Agreement
 "I-UDA": [
  { label: 'Code', key: 'code' },
  { label: 'Status', key: 'status' },
  { label: 'Development Budget', key: 'development_budget' },
  { label: 'Start Date', key: 'start_date' },
  { label: 'End Date', key: 'end_date' }
],

// ✅ Milestones
"MS00": [
  { label: 'Amount', key: 'amount' },
  { label: 'Date', key: 'date' }
],
"MS01": [
  { label: 'Amount', key: 'amount' },
  { label: 'Date', key: 'date' }
],
"MS02": [
  { label: 'Amount', key: 'amount' },
  { label: 'Date', key: 'date' }
],
"MS03": [
  { label: 'Amount', key: 'amount' },
  { label: 'Date', key: 'date' }
],
"MS04": [
  { label: 'Amount', key: 'amount' },
  { label: 'Date', key: 'date' }
],
"MS05": [
  { label: 'Amount', key: 'amount' },
  { label: 'Date', key: 'date' }
],

// ✅ PSQRs to SQRs
"makeI_23": [
  { label: 'Justification', key: 'justification' }
],

// ✅ AoN & SoC
"AoNSoC": [
  { label: 'AON Date', key: 'aon_date' },
  { label: 'AON Quantity', key: 'aon_qty' },
  { label: 'AON Cost', key: 'aon_cost' }
]
};